module.exports = __webpack_public_path__ + "static/media/postcard5thumb.37ba4dfc.jpg";